/**
 * Checks if a given phone number is valid.
 * @param {string} [phone] - The phone number to be checked.
 * @returns {boolean} Returns true if the phone number is valid, false otherwise.
 */
export function isValidPhoneNumber(phone = '') {
  return /^(\+?\d{1,3}[-.\s]?)?(\(?\d{1,4}\)?[-.\s]?)?[\d\-.\s]{5,}$/.test(phone.trim());
}
